import { z } from 'zod';
import { idSchema } from './common.js';
/**
 * Suche ueber alle Boards (SPEC 6).
 *
 * Mindestens zwei Zeichen: bei einem einzelnen Buchstaben trifft der
 * Teiltext-Zweig fast jede Karte, und das Ergebnis waere kein Ergebnis.
 */
export const SEARCH_MIN_LENGTH = 2;
export const searchQuerySchema = z.object({
    q: z.string().trim().min(SEARCH_MIN_LENGTH).max(100),
    /** Auf ein Board einschraenken; ohne Angabe wird ueberall gesucht. */
    boardId: idSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(30),
});
//# sourceMappingURL=search.js.map